import { render, staticRenderFns } from "./ModalSliderItem.vue?vue&type=template&id=4d060e93&lang=pug&"
import script from "./ModalSliderItem.vue?vue&type=script&lang=js&"
export * from "./ModalSliderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports